import axios from 'axios';

const api = axios.create({
  baseURL:         import.meta.env.VITE_API_URL || '/api',
  timeout:         15000,
  withCredentials: true,   // send httpOnly refresh cookie
  headers:         { 'Content-Type': 'application/json' },
});


// ─── Single-flight session refresh ────────────────────────────────────────────
// The refresh cookie is single-use and ROTATES on every /auth/refresh. Two
// concurrent refreshes carrying the same cookie race: the first rotates +
// invalidates it, the second gets 401 "Session expired" and logs the user out.
// A page load hits exactly this — the AuthContext session-restore effect and
// the 401 interceptor both want to refresh. Funnelling every refresh through
// ONE shared in-flight promise collapses them into a single network call.
// Both this module and AuthContext import refreshSession so they truly share
// it (the previous window.__glkHrRefreshPromise covered the bootstrap path but
// NOT the interceptor, so the two could still race).
let refreshPromise = null;
export function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = api.post('/auth/refresh').finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const isRefreshCall = original.url?.includes('/auth/refresh');
    if (error.response?.status === 401 && !original._retry && !isRefreshCall) {
      original._retry = true;
      try {
        const { data } = await refreshSession();
        api.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
        original.headers['Authorization'] = `Bearer ${data.accessToken}`;
        return api(original);
      } catch (refreshError) {
        window.dispatchEvent(new CustomEvent('glk-hr:session-expired'));
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
